import { motion, useScroll, useSpring, useTransform } from "framer-motion";

const SPRITES = [
    { at: 0.06, top: "7%", side: "left", kind: "leaf" },
    { at: 0.16, top: "17%", side: "right", kind: "leaf" },
    { at: 0.26, top: "27%", side: "left", kind: "flower" },
    { at: 0.36, top: "37%", side: "right", kind: "leaf" },
    { at: 0.47, top: "47%", side: "left", kind: "leaf" },
    { at: 0.57, top: "57%", side: "right", kind: "flower" },
    { at: 0.67, top: "67%", side: "left", kind: "leaf" },
    { at: 0.78, top: "77%", side: "right", kind: "leaf" },
    { at: 0.89, top: "87%", side: "left", kind: "flower" },
];

const Sprite = ({ progress, at, top, side, kind }) => {
    const scale = useTransform(progress, [at, at + 0.05], [0, 1]);
    const opacity = useTransform(progress, [at, at + 0.05], [0, 1]);
    return (
        <motion.div
            style={{ scale, opacity, top }}
            className={`absolute ${side === "left" ? "left-0" : "right-0"}`}
            aria-hidden="true"
        >
            {kind === "leaf" ? (
                <svg width="30" height="30" viewBox="0 0 30 30">
                    <path
                        d={side === "left" ? "M24 24C10 26 4 18 4 8c11-1 18 5 20 16z" : "M6 24c14 2 20-6 20-16C15 7 8 13 6 24z"}
                        fill="#8FB38A"
                        stroke="#5E8355"
                        strokeWidth="1.6"
                    />
                </svg>
            ) : (
                <svg width="26" height="26" viewBox="0 0 26 26">
                    {[0, 72, 144, 216, 288].map((deg) => (
                        <ellipse key={deg} cx="13" cy="6.5" rx="3.4" ry="4.6" fill={at > 0.5 ? "#E07A5F" : "#F6C544"} transform={`rotate(${deg} 13 13)`} />
                    ))}
                    <circle cx="13" cy="13" r="3.6" fill="#FFF8EC" />
                </svg>
            )}
        </motion.div>
    );
};

export default function GrowingVine() {
    const { scrollYProgress } = useScroll();
    const progress = useSpring(scrollYProgress, { stiffness: 55, damping: 18, restDelta: 0.001 });

    return (
        <div className="fixed left-3 top-0 h-screen w-16 hidden xl:block pointer-events-none z-10" aria-hidden="true" data-testid="home-growing-vine">
            <svg viewBox="0 0 64 1000" preserveAspectRatio="none" className="h-full w-full">
                <motion.path
                    d="M32 -20 C 52 140, 12 260, 32 400 C 52 540, 12 660, 32 800 C 46 900, 32 960, 32 1020"
                    fill="none"
                    stroke="#5E8355"
                    strokeWidth="5"
                    strokeLinecap="round"
                    style={{ pathLength: progress }}
                />
            </svg>
            {SPRITES.map((s) => (
                <Sprite key={s.at} progress={progress} {...s} />
            ))}
        </div>
    );
}
